_ = require('lodash')

module.exports = ( User ) ->
  return {
    restrict: 'A'

    scope:
      projectPermissions:   '=stepFindingsProjectPermissions'
      step:                 '='
      steps:                '=?'
      workflows:            '='
      starredDocsComments:  '='
      projectStarredDocs:   '='
      starredDocs:          '='
      entity:               '='
      showExcluded:         '=?'
      removeStarredDoc:     '='
      newStarredResult:     '='
      saveDocTags:          '='
      getIsDocSelected:     '='
      setIsDocSelected:     '='
      numberOfSelectedDocs: '&'
      allDocsSelected:      '&'
      toggleSelectedDocs:   '&'
      saveSelectedDocsTags: '&'

    controller: ( $scope, Api, $uibModal, $rootScope ) ->
      $scope.summary = $scope.step.summary
      $scope.User = User

      filterExcluded = ( docs ) ->
        tagsToExclude = _(User.client_tagging_configs)
          .map((tagging_config) -> tagging_config.config.exclude or [])
          .flatten()
          .value()
        filtered = {}
        for key, doc of docs
          isExcluded = _.any(doc.tags, (docTag) -> _.contains(tagsToExclude, docTag))
          if !isExcluded then filtered[ key ] = doc
        filtered

      getResultOrDoc = (doc) ->
        # this is for cases when document is not a SearchResult, e.g. an uploaded document
        if !!doc.result then doc.result else doc

      getStarredDocsArray = () ->
        _.values($scope.getStarredDocs()).map(getResultOrDoc)

      $scope.getStarredDocs = () ->
        starredDocs = $scope.projectStarredDocs[ $scope.step.id ] || {}
        if !$scope.showExcluded
          starredDocs = filterExcluded( starredDocs )
        starredDocs

      $scope.sortByClientConfig = (items) ->
        order = User.client_tagging_configs?[0]?.config.resultsOrder
        if not order
          return _.sortBy(items, (i) -> i.title.toLowerCase())

        getLowestOrderValue = (tags) ->
          return _.min(
            (if order.indexOf(tag) > -1 then order.indexOf(tag) else order.length) for tag in tags
          )

        return _.sortBy(items, (i) -> getLowestOrderValue(i.tags))

      $scope.shouldShowMoveButton = () ->
        stepCount = ( k for own k of $scope.steps ).length
        stepCount > 1

      $scope.isSummaryChanged = () ->
        $scope.summary != $scope.step.summary

      $scope.saveSummary = () ->
        stepId = $scope.step.id
        $scope.savingSummary = true
        $rootScope.exportControllerFormDirty = false
        new Api.WorkflowStep({ id: stepId, summary: $scope.summary }).$update().then ->
          $scope.savingSummary = false
          $scope.step.summary = $scope.summary

      $scope.onSummaryEdit = () ->
        $rootScope.exportControllerFormDirty = true

      $scope.isEmpty = ( obj ) ->
        (d for k, d of obj when d.deleted isnt true).length == 0

      # Checks if the document can be deleted:
      # - It must be manually uploaded (indicated by search_result is null)
      # - The user must have 'workflow.delete_projectstarreddocument' permission
      $scope.canDeleteDocument = (doc, user) ->
        !doc?.search_result and user.hasPermission('workflow.delete_projectstarreddocument', false)

      $scope.uploadDoc = () ->
        starredUploadModal = $uibModal.open
          template: require('../../components/StarredDocumentUpload/starred-doc-upload-modal.html')
          controller: 'StarredDocumentUploadController'
          size: 'lg'
          resolve:
            workflowStep: () ->
              return $scope.step
            manualSource: () ->
              return undefined
        starredUploadModal.result.then (starredDocs) ->
          stepId = $scope.step.id
          $scope.projectStarredDocs[ stepId ] = {} if $scope.projectStarredDocs? and not $scope.projectStarredDocs[ stepId ]
          for doc in starredDocs.docs
            $scope.starredDocs[ doc.id ] = $scope.getStarredDocs()[doc.id] = new Api.ProjectStarredDocument doc

      $scope.createDoc = () ->
        starredCreateModal = $uibModal.open
          template: require('../../components/StarredDocumentCreate/starred-doc-create-modal.html')
          controller: 'StarredDocumentCreateController'
          size: 'lg'
          resolve:
            workflowStep: () ->
              return $scope.step
            manualSource: () ->
              return undefined
        starredCreateModal.result.then (starredDoc) ->
          if starredDoc
            stepId = $scope.step.id
            $scope.projectStarredDocs[ stepId ] = {} if $scope.projectStarredDocs? and not $scope.projectStarredDocs[ stepId ]
            $scope.starredDocs[ starredDoc.id ] = $scope.getStarredDocs()[starredDoc.id] = new Api.ProjectStarredDocument starredDoc

      $scope.allDocsOnPageSelected = () ->
        $scope.allDocsSelected({docsOnPage: getStarredDocsArray()})

      $scope.toggleSelectedDocsOnPage = () ->
        $scope.toggleSelectedDocs({docsOnPage: getStarredDocsArray()})

      $scope.saveSelectedDocsOnPageTags = (tagIdsToSave, annotation) ->
        $scope.saveSelectedDocsTags({docsOnPage: getStarredDocsArray(), tagIdsToSave: tagIdsToSave, annotation: annotation})

    template: require('./step-findings.html')
  }
